export default __webpack_public_path__ + "static/media/ico-wallet.2b60b57f.svg";